// extracted by mini-css-extract-plugin
export default {"select":"styles_select__yHhbC","select-options":"styles_select-options__Q9Qvg","label":"styles_label__11aSv"};